<template>
    <v-card>
        <v-toolbar dark class="primary">
            <v-btn icon @click.native="$emit('close')" dark>
                <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear :indeterminate="true" v-if="quickClientSaving"></v-progress-linear>
        <v-card-text v-show="!quickClientSaving">
            <v-form @submit.prevent="saveQuickClient">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Imię*" v-validate="'required'" name="qaddname" id="qaddname"
                                data-vv-as="Imię" :error-messages="errors.collect('qaddname')"
                                v-model="name"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Nazwisko*" v-validate="'required'" name="qaddsurname" id="qaddsurname"
                                :error-messages="errors.collect('qaddsurname')" data-vv-as="Nazwisko"
                                v-model="surname"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Telefon" v-validate="{ regex: /^[0-9\+]{8,13}$/ }" name="qaddphone"
                                id="qaddphone" :error-messages="errors.collect('qaddphone')" data-vv-as="Telefon"
                                v-model="phone"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Adres email" name="emailAddress" id="emailAddress"
                                v-model="emailAddress"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="PESEL" v-validate="{ regex: /^[0-9]{11}$/ }" name="qaddpesel"
                                id="qaddpesel" :error-messages="errors.collect('qaddpesel')" data-vv-as="PESEL"
                                :rules="[value => validatePesel(value) || 'Niepoprawny numer PESEL']"
                                v-model="PESEL"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="NIP" name="NIP" id="NIP" data-vv-as="Numer NIP"
                                v-validate="{ regex: /^[0-9A-Z\-]*$/ }" v-mask="nip_mask"
                                :error-messages="errors.collect('NIP')" v-model="NIP"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="Data urodzenia"
                                :value="birthDate ? birthDate.toLocaleDateString() : 'Nieznana'"
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Wiek" :value="age !== null ? age + ' lat' : 'Nieznany'"
                                readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-checkbox label="Zgoda na sms" v-model="usePhoneForSMS"></v-checkbox>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-checkbox label="Płaci PAYU" v-model="payByPayU"></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>

            </v-form>
        </v-card-text>
        <v-card-actions v-show="!quickClientSaving">
            <v-btn color="success" @click="saveQuickClient">Zapisz</v-btn>
            <v-btn color="error" @click="$emit('close')">Anuluj</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { clientService } from "@/services/";
import swal from "sweetalert";
import { mask } from 'vue-the-mask'

export default {
    name: "QuickAddClient",
    directives: {
        mask
    },
    data() {
        return {
            name: null,
            surname: null,
            phone: null,
            PESEL: null,
            NIP: null,
            birthDate: null,
            age: null,
            usePhoneForSMS: false,
            payByPayU: false,
            quickClientSaving: false,
            emailAddress: null,
            nip_mask: '###-###-##-##',
        }
    },
    props: ['addressdetails', 'title'],
    watch: {
        PESEL(newPesel) {
            this.setGenderFromPesel(newPesel);
            this.calculateBirthDateAndAge(newPesel);
        },
    },
    methods: {
        calculateBirthDateAndAge(pesel) {
            if (!/^\d{11}$/.test(pesel)) {
                this.birthDate = null;
                this.age = null;
                return;
            }

            const yearBase = parseInt(pesel.substring(0, 2), 10);
            const month = parseInt(pesel.substring(2, 4), 10);
            const day = parseInt(pesel.substring(4, 6), 10);

            let year;
            if (month > 80) {
                year = 1800 + yearBase;
            } else if (month > 60) {
                year = 2200 + yearBase;
            } else if (month > 40) {
                year = 2100 + yearBase;
            } else if (month > 20) {
                year = 2000 + yearBase;
            } else {
                year = 1900 + yearBase;
            }

            const correctedMonth = month % 20; // Usunięcie przesunięcia wieku
            this.birthDate = new Date(year, correctedMonth - 1, day);

            const today = new Date();
            this.age = today.getFullYear() - year;
            if (
                today.getMonth() < correctedMonth - 1 ||
                (today.getMonth() === correctedMonth - 1 && today.getDate() < day)
            ) {
                this.age--;
            }
        },
        setGenderFromPesel(pesel) {
            if (/^\d{11}$/.test(pesel)) {
                const genderDigit = parseInt(pesel[9], 10); // 10. cyfra PESEL
                this.gender = genderDigit % 2 === 0 ? 1 : 0; // 1 = Kobieta, 0 = Mężczyzna
            } else {
                this.gender = -1; // Resetuj płeć, jeśli PESEL jest niepoprawny
            }
        },
        validatePesel(pesel) {
            if (!pesel) {
                return true; // Jeśli PESEL jest pusty, nie waliduj
            }
            if (!/^\d{11}$/.test(pesel)) {
                return false; // PESEL musi składać się z 11 cyfr
            }

            const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
            const digits = pesel.split('').map(Number);
            const checksum = digits.slice(0, 10).reduce((sum, digit, index) => sum + digit * weights[index], 0);
            const controlDigit = (10 - (checksum % 10)) % 10;

            return controlDigit === digits[10];
        },
        saveQuickClient() {
            this.$validator.validateAll().then(valid => {
                if (valid) {
                    this.quickClientSaving = true;
                    clientService
                        .create({
                            name: this.name,
                            surname: this.surname,
                            phone: this.phone,
                            pesel: this.PESEL,
                            nip: this.NIP ? this.NIP.replace('-', '') : null,
                            street: this.addressdetails ? this.addressdetails.street : null,
                            postcode: this.addressdetails ? this.addressdetails.postcode : null,
                            city: this.addressdetails ? this.addressdetails.city : null,
                            region: this.addressdetails ? this.addressdetails.region : null,
                            payByPayU: this.payByPayU,
                            emailAddress: this.emailAddress,
                            usePhoneForSMS: this.usePhoneForSMS,
                            patientAgreeToReceiveSMS: this.usePhoneForSMS,
                            patientConfirmVisitsBySMS: this.usePhoneForSMS,
                        })
                        .then(resp => {
                            if (resp.data != null && resp.data.result != null) {
                                let quickClient = resp.data.result;
                                this.$emit('success', quickClient)
                            } else {
                                this.showError(false, "Błąd zapisu");
                            }
                        })
                        .catch(resp => {
                            this.quickClientSaving = false;
                            if (
                                resp.response != null &&
                                resp.response.data != null &&
                                resp.response.data.error != null
                            ) {
                                this.showError(false, resp.response.data.error.message);
                            } else {
                                this.showError(false, "Błąd zapisu");
                            }
                        });
                }
            });
        },
        showError(close, text) {
            swal({
                title: "Błąd",
                text: text,
                icon: "warning",
                button: "OK"
            }).then(() => {
                this.loading = false;
                if (close) {
                    this.$emit("close");
                }
            });
        },
    }
}
</script>

<style scoped></style>